import { render, staticRenderFns } from "./notifyMsg.vue?vue&type=template&id=42f0e922&scoped=true"
import script from "./notifyMsg.vue?vue&type=script&lang=js"
export * from "./notifyMsg.vue?vue&type=script&lang=js"
import style0 from "./notifyMsg.vue?vue&type=style&index=0&id=42f0e922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0e922",
  null
  
)

export default component.exports